import { useState } from 'react';

import type { AddClientContactSheetData } from '@/entities/client';
import { useSheetStore } from '@/shared/stores/sheet-store';

// The store drops the opening the instant the sheet is left, but Radix keeps the content mounted
// while it slides out. Holding the last opening keeps the form from unmounting mid-animation, and
// replacing it per opening (not per client) gives a sheet reopened for the same client a fresh form.
export function useAddClientContactSheet(): AddClientContactSheetData | undefined {
    const currentSheet = useSheetStore((state) => state.currentSheet);

    const openOpening =
        currentSheet?.type === 'clients/add-contact' ? currentSheet.data : undefined;

    const [retainedOpening, setRetainedOpening] = useState(openOpening);
    if (openOpening && openOpening.openingId !== retainedOpening?.openingId) {
        setRetainedOpening(openOpening);
    }

    return openOpening ?? retainedOpening;
}
